module.exports = __webpack_public_path__ + "img/bg-wave.04e7e501.svg";